import {
	openMask,
	closeMask,
	openError
} from '../mainModule/action';
import Axios from 'core/axios';
import Rest from 'core/rest';
import { getLocale } from 'core/i18n';
export const HOME_SEARCH_BOOKINGS_SUCCESS = 'HOME_SEARCH_BOOKINGS_SUCCESS';
export const HOME_CLEAN_BOOKINGS = 'HOME_CLEAN_BOOKINGS';
export const HOME_GET_BOOKING_DATA_SUCCESS = 'HOME_GET_BOOKING_DATA_SUCCESS';
export const HOME_TAX_REFUND_DIALOG = 'HOME_TAX_REFUND_DIALOG';
export const HOME_OPEN_REMOVE_UNPAID_BOOKING_DIALOG = 'HOME_OPEN_REMOVE_UNPAID_BOOKING_DIALOG';
export const HOME_REMOVE_UNPAID_BOOKING_DIALOG = 'HOME_REMOVE_UNPAID_BOOKING_DIALOG';
export const HOME_CLEAN_BOOKING_DATA = 'HOME_CLEAN_BOOKING_DATA';

export const searchBookings = (data, tab) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.booking.postBooking(), data)
			.then((response) => {
				dispatch(closeMask());
				return dispatch({
					type: HOME_SEARCH_BOOKINGS_SUCCESS,
					data: response.data,
					tab
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const cleanBookings = () => {
	return (dispatch) => {
		dispatch({
			type: HOME_CLEAN_BOOKINGS
		});
	};
};

export const getBooking = (recordLocator) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.get(Rest.booking.getBooking('recordLocator', recordLocator))
			.then((response) => {
				dispatch(closeMask());
				console.log(response);
				return dispatch({
					type: HOME_GET_BOOKING_DATA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const removeUnpaidBooking = (recordLocator) => {
	const pnr = recordLocator.replace(/^([A-Za-z0-9]{6,7}).*$/, '$1');

	return (dispatch) => {
		dispatch(openMask());
		Axios.delete(Rest.booking.cancelBooking(pnr))
			.catch((error) => dispatch(openError(error)))
			.finally(() => dispatch({
				pnr,
				type: HOME_REMOVE_UNPAID_BOOKING_DIALOG 
			}));
	};
};

export const submitTaxRefund = (recordLocator, pax, onSuccess, onError, onGeneralError) => {
	return (dispatch) => {
		dispatch(openMask());
		//Axios.get(Rest.common.getTaxRefundTest()) //測試用 API
		Axios.post(Rest.taxRefund.postTaxRefund(), { recordLocator, pax })
			.then((response) => {
				dispatch(closeMask());
				const data = response.data;
				if (Array.isArray(data)) {
					if (data.length > 0) {
						// 有乘客層級的錯誤訊息
						if (typeof onError === 'function') {
							onError(data);
						}
					} else {
						// 沒有錯誤訊息就是成功
						if (typeof onSuccess === 'function') {
							onSuccess();
						}
					}
				} else if (data && typeof data === 'object' && !Array.isArray(data) && data.code !== undefined && data.code !== null) {
					// 整張訂單層級的錯誤 (跟乘客無關), code 對應錯誤代碼 (例如 200 = 000200)
					if (typeof onGeneralError === 'function') {
						onGeneralError(data);
					}
				} else {
					// 沒有錯誤訊息就是成功
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
				}
			})
			.catch((error) => {
				dispatch(closeMask());
				const responseData = error && error.response && error.response.data;
				if (responseData && typeof responseData === 'object' && !Array.isArray(responseData) && responseData.code !== undefined && responseData.code !== null) {
					// HTTP 500 但 response body 帶有 {code, message, data} 格式的整單錯誤
					if (typeof onGeneralError === 'function') {
						onGeneralError(responseData);
						return;
					}
				}
				return dispatch(openError(error));
			});
	};
};

export const cleanBookingData = () => {
	return (dispatch) => {
		dispatch({
			type: HOME_CLEAN_BOOKING_DATA
		});
	};
};

export const getBookingPDF = (pnr, locale) => {
	return (dispatch) => {
		dispatch(openMask());
		var request = new XMLHttpRequest();
		request.open('GET', Rest.booking.getBookingPDF(pnr, locale), true);
		request.setRequestHeader('Authorization', JSON.parse(sessionStorage.getItem('user')).token);
		request.responseType = 'blob';
		request.onload = function (e) {
			if (this.status === 200) {
				var file = window.URL.createObjectURL(this.response);
				window.open(file);
				dispatch(closeMask());
			} else {
				dispatch(closeMask());
				return dispatch(openError(this.response.error));
			};
		};
		request.send();
	};
};

export const getPortalToken = (pnr, mode, urlParameter) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.session.postPortal(pnr))
			.then((response) => {
				dispatch(closeMask());
				switch (mode) {
					case 'ibe':
						setTimeout(() => {
							window.open(`${Rest.directUrl.IBEUrl}/?token=${response.data.token}${urlParameter}`);
						}, 10);
						break;
					case 'mmb':
						setTimeout(() => {
							const url = `${Rest.directUrl.MMBUrl}/?lang=${getLocale()}&token=${response.data.token}`;
							console.log(url);
							window.open(url);
						}, 10);
						break;
					default:
						break;
				}
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};